import React, { useEffect, useRef } from "react";
import { CheckCircle } from "lucide-react";
import { PizzaTimerProps } from "../types";

const PizzaTimer: React.FC<PizzaTimerProps> = ({
  activeTimer,
  timeElapsed,
  isFinalizing = false,
  onStop,
  getPizzaIcon,
  formatTime,
}) => {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const hasPlayedSoundRef = useRef(false);

  useEffect(() => {
    audioRef.current = new Audio("/producao.mp3");
    audioRef.current.volume = 1.0;

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    hasPlayedSoundRef.current = false;
  }, [activeTimer]);

  useEffect(() => {
    if (isFinalizing || hasPlayedSoundRef.current || !audioRef.current) {
      return;
    }

    const isPizzaTrem = activeTimer === "Trem";
    const timeLimit = isPizzaTrem ? 120 : 90;

    if (timeElapsed >= timeLimit && !hasPlayedSoundRef.current) {
      hasPlayedSoundRef.current = true;
      audioRef.current.currentTime = 0;
      audioRef.current.play().catch((error) => {
        console.error("Erro ao reproduzir o som:", error);
      });
    }
  }, [timeElapsed, activeTimer, isFinalizing]);

  return (
    <div className="animate-fadeInUp relative mx-auto mb-8 max-w-md overflow-hidden rounded-3xl border-4 border-primary bg-gradient-to-br from-white via-red-50 to-orange-50 p-4 text-center shadow-2xl sm:p-6">
      <div className="relative z-10 mb-8">
        <div className="mb-4 flex items-center justify-center">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary shadow-lg">
            <span className="animate-bounce text-3xl">
              {getPizzaIcon(activeTimer)}
            </span>
          </div>
        </div>
        <h3 className="mb-2 bg-gradient-to-r from-primary to-red-600 bg-clip-text text-2xl font-bold text-transparent sm:text-3xl">
          Preparando Pizza
        </h3>
        <div className="inline-block rounded-full bg-primary px-6 py-2 text-lg font-semibold text-white shadow-lg">
          {activeTimer}
        </div>
      </div>

      <div className="relative z-10 mb-8">
        <div className="rounded-2xl border-2 border-red-100 bg-white/80 p-3 shadow-inner backdrop-blur-sm">
          <div className="bg-gradient-to-r from-primary via-red-600 to-orange-600 bg-clip-text font-mono text-4xl font-bold tracking-wider text-transparent drop-shadow-lg sm:text-5xl">
            {formatTime(timeElapsed)}
          </div>
          <div className="mt-1 text-xs font-medium text-neutral-600">
            Tempo decorrido
          </div>
        </div>
      </div>

      <div className="relative z-10">
        <button
          type="button"
          onClick={onStop}
          disabled={isFinalizing}
          className="group transform rounded-2xl border-2 border-green-400 bg-green-600 px-12 py-4 text-xl font-bold text-white shadow-2xl transition-all duration-300 hover:scale-105 hover:bg-green-700 hover:shadow-green-500/25 disabled:cursor-not-allowed disabled:opacity-50 disabled:hover:scale-100"
        >
          <span className="flex items-center justify-center">
            <CheckCircle
              className="mr-3 group-hover:animate-bounce"
              size={24}
            />
            <span>{isFinalizing ? "Finalizando..." : "Finalizar Pizza"}</span>
          </span>
        </button>
      </div>
    </div>
  );
};

export default PizzaTimer;
